import Backbone from 'backbone'
import _ from 'lodash'
import config from 'scoreboard/components/config'
import calendars from 'scoreboard/components/calendars'
import formHelper from 'scoreboard/components/form-helper'
import dropdown from 'scoreboard/components/dropdown'
import template from './annual-metric-data-options.hbs'
import metricTableOptions from 'scoreboard/scorecards/metrics/metrics-table-options.hbs'

var AnnualMetricDataOptions = Backbone.View.extend({

	tagName: 'form',

	className: 'reports annual-metric-data-options display-options-form margin-collapse',

	events: {
		'change input[type=checkbox]': 'toggleDisplayOpts',
		'change select[name]': 'gatherCalendarData'
	},

	render: function() {
		this.$el.html(template())
		this.$('.column-checks').html(metricTableOptions())

		dropdown.idLabels(this.$('[name=annualCalendarPeriodId]'),
			calendars.calendarsById[config.ytdCalendarId].periods)
		dropdown.idLabels(this.$('[name=breakdownCalendarId]'), calendars.calendars)

		var data = _.assign(_.pick(this.model.attributes, 'annualCalendarPeriodId', 'breakdownCalendarId'),
			this.model.get('displayOptions'))
		formHelper.writeToDom(data, this.el)

		if (!config.scoresVisible) {
			this.$('[name=showScore]').closest('label').hide()
		}

		return this
	},

	toggleDisplayOpts: function(e) {
		var cb = this.$(e.target)
		this.model.get('displayOptions')[cb.attr('name')] = cb.is(':checked')
		this.model.trigger('change')
	},

	 gatherCalendarData: function(e) {
	 	var sel = this.$(e.target)
	 	this.model.set(sel.attr('name'), sel.val())
	 }

})

export default AnnualMetricDataOptions


AnnualMetricDataOptions.__filename__ = 'reports/wizard/annual-metric-data/annual-metric-data-options.js'
